var youtubevideos=[
    {
        name:"Trailer Transportation",
        video:"eG27p-V64v4"
    },
    {
        name:"",
        video:"wXfHH-QDqXo"
    },
    {
        name:"Mobile tower crane",
        video:"Q1uWeQMutLQ"
    },
    {
        name:"Axles",
        video:"HkyLGhI6lcQ"
    },
    {
        name:"Axles",
        video:"1wR_kU9fhVI"
    },
    {
        name:"Axles",
        video:"fzvTcd0Eez8"
    },
    {
        name: "Tekkali Railway gate crossing video",
        video:"uYrbe4lgSf4"
    },
    {
        name: "Yeturunagaram Video",
        video:"2i0XoeF2ocQ"
    },
    {
        name: "Liebherr LR-1280 crane",
        video: "XTM9iYn4b-g"
    },
    {
        name: "112 feet Grider Transportation From Vizag to Tekkali - Bolster Operation and Railway Line crossing",
        video: "kRNLSPeh8jU"
    },
    {
        name: "Pullers Hydraulic Axles",
        video: "CLoI5MC5bk0"
    },
    {
        name: "Pullers Hydraulic Axles 1",
        video:"CEDw_wCmh5w"
    },
    {
        name: "Liebherr 400 Ton All Terrain Crane Time Lapse",
        video:"IgG_PiOK_Ys"
    },
    {
        name: "Liebherr LTM 1400-7.1",
        video: "kUASMPm_8Rw"
    },
    {
        name: "Site work of Iffco Paradeep",
        video: "w9jk51ytMXE"
    },
    {
        name: "Liebherr LTM 1150-5.3 - The Jewel in Your Fleet",
        video: "KjzqdbvcguE"
    },
    {
        name: "PBL Work",
        video: "7OOQa20aRGo"
    },
    {
        name: "Project work",
        video: "17pt9ne4WE8"
    },
    {
        name: "Trailer Transportation 4",
        video: "fQDLYG3GJu4"
    }
]

export {youtubevideos}